import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

const dsn = process.env.REACT_SENTRY_DSN;

if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.REACT_SENTRY_ENV || 'development',
		allowUrls: [/https?:\/\/((www)\.)?marsblade\.com/],
		ignoreErrors: ['Non-Error promise rejection captured'],
	});
}

hydrate();
